import Component from "../../lib/component";
import { identifyElement } from "../../helpers/element";

export const DropdownNavConfig = {
  componentTypeKey: "DropdownNav",
  baseHtmlClass: "dropdown_nav",
  selector: ".dropdown_nav",

  datasetConfigKey: "dropdown_nav__config",
};

export class DropdownNav extends Component {

    static get config() {
        return DropdownNavConfig;
    }

    constructor(id_or_element, dropdown) {
        super({
            element: id_or_element,
            config: DropdownNav.config
        });

        this.dropdown = dropdown;

        this.setDatasetConfig(DropdownNav.config.datasetConfigKey);

        this.listElement = this.element.querySelector('ul');

        // If there is "In Page" configuration then the nav is considered an in-page nav and will scan the page for items to automatically add to the nav.
        this.inPageConfig = this.getDatasetConfigValue('in_page_config');
        this.isInPageNav = !!(this.inPageConfig);
        if (this.isInPageNav) {
            this.inPageSectionSelector = this.inPageConfig['section_selector'] || 'section';
            this.inPageTitleSelector = this.inPageConfig['title_selector'] || "section > h2, section > h3";
            this.addInPageNavItems();
        }

        this.render();
    }


    render() {
        this.swapHtmlClassStates(this.isOpen(), 'open', 'closed');
        this.moveIntoViewport();
    }

    moveIntoViewport() {
        const rect = this.element.getBoundingClientRect();
        const rightOverflow = rect.right - window.innerWidth;
        this.element.style.transform = (rightOverflow > 0) ? `translateX(-${rightOverflow}px)` : null;
    }

    isOpen() {
        return this.dropdown.isOpen();
    }

    addInPageNavItems() {
        if (!this.isInPageNav) return;
        
        const sections = document.querySelectorAll(this.inPageSectionSelector);
        sections.forEach((section) => {
            section.id = identifyElement(section);

            const title = section.querySelector(this.inPageTitleSelector);
            if (!title) return;
            const titleText = title.textContent.trim();
            if (!titleText) return;

            const navItem = createInPageNavItemElement(titleText, section.id);
            this.listElement.appendChild(navItem);
        });
    }

}

function createInPageNavItemElement(titleText, sectionId){
    // Create a temp DOM element and set the innerHTML to the template literal. Then we can return the first child element.
    const tempElement = document.createElement('div');
    const template = `
<li class="dropdown_nav__item">
    <div class="dropdown_option">
        <a href="#${sectionId}">${titleText}</a>
    </div>
</li>
`
    tempElement.innerHTML = template.trim();
    return tempElement.firstChild;
}